import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_znf6yq3uqj: FaireCollectionEntity = {
  token: "pbc_znf6yq3uqj",
  type: "collection",
  name: "First Look: Fall 2026",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f4862cac21a114a6f2a23783c413623d22a04293a39d40f7e44ede2dedb6e4b5.png",
  itemCount: 20,
  description:
    "🍂 Get an exclusive first look at Fall 2026. Discover our newest fit names, innovative fabric technology, sculpting construction, and trend-forward silhouettes—all designed with the signature comfort Judy Blue is known for. More arrivals are on the way.",
  brandToken: "b_d5ug42njab",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T00:35:14.404Z",
    importedBy: "entity-db-import-collections",
  },
};
